import React from "react";
import { LabelModes } from "../../../ui-components/molecules/labeled-inputs/labeledInput";
import { Contact } from "../../../app/data/terminal-details/models";
import XGSFormInput from "../../../ui-components/form/input/xgsFormInput";
import XGSFormSelect from "ui-components/form/select/xgsFormSelect";
import usaStates from "app/data/common/usaStates";
import { useFormikContext } from "formik";


const AgentAddressDetails = () => {
    const { values, setFieldValue } = useFormikContext<Contact>();
    return (
        <>
            <div className="edit-flex-box">
                <XGSFormInput
                    type="text"
                    name="agentAddress"
                    labelMode={LabelModes.column}
                    label="Agent Address"
                />
                <div className="edit-flex-box__item">
                    <XGSFormInput
                        type="text"
                        name="agCity"
                        label="City"
                        className="width-50"
                        labelMode={LabelModes.column}
                    />
                    <XGSFormSelect
                        label="State"
                        name="agState"
                        isClearable
                        required={false}
                        options={usaStates}
                        value={values.agState ? usaStates.find(
                            (option) => option.value === values.agState
                        ) : null}
                        onValueChange={(option) => {
                            setFieldValue("agState", option?.value ?? "");
                        }}
                        className="width-50"
                        labelMode={LabelModes.column}
                    />
                </div>
            </div>

        </>
    );
};

export default AgentAddressDetails;
